import type {CompanyProfile} from "../ProfileStore.tsx";

export type DatabagConfiguration = {
    databag_id: number
    columns: ColumnConfiguration[]
}

export type ColumnConfiguration = {
    table_name: string
    column_name: string
    dj_type: string | null
    stat_count: number
    stat_unique: number
    stat_empty: number
    stat_null: number
    stat_is_number: number
    stat_min: string
    stat_max: string

    display_name: string
    description: string
    in_use: boolean
    default_visibility: boolean
    mh_in_use: boolean
    mh_default_visibility: boolean
    default_order: number | null
    width: number | null
    min_width: number | null
    max_width: number | null
    available_filters: string[]
}

/** Default available_filters for columns that aren't backed by a real ColumnConfiguration row (dj_type: null). */
export const DEFAULT_STRING_FILTER_OPERATOR_IDS: string[] = [
    'contains', 'equals', 'starts_with', 'ends_with', 'is_empty', 'is_not_empty', 'is_any_of',
];

type Value = number | string | boolean | object;

// SUPPLIER_360_SHOW_SV_LOGO/SUPPLIER_360_SHOW_DNB_LOGO moved off customer config 2026-10-22, per the
// user — see useSourceLogoAllowed.ts, which now reads InfoSource.show_logo (cat-material) instead.
export type CustomerConfigurationKeys =
    'LOCALE'
    | 'CURRENCY'
    | 'DATA_YEAR_START'
    | 'DISABLE_PPV'
    | 'DISABLE_GINI'
    | 'TEST_REVIEW_PAGE'
    | 'CATEGORIZATION_SCORE'
    | 'CATEGORIZATION_FILE_DL'
    | 'ADV_DASH_GRAPHS'
    | 'MH_UNLIMITED_ACCESS'

export type CustomerConfiguration = {
    key: CustomerConfigurationKeys
    value: Value | Value[] | {[key: string]: Value | Value[]}
}
export type CustomerConfigurationMap = Map<CustomerConfigurationKeys, CustomerConfiguration>;

export type ProfileKeyMapType = {
    [key in CustomerConfigurationKeys]?: {
        pKey: keyof CompanyProfile | null,
        default: any,
        operation?: (value: any) => any,
    }
}

/**
 * TODO [CAT-3252]: Once FE is migrates we can phase this out
 */
export const ProfileKeyMap: ProfileKeyMapType = {
    'CATEGORIZATION_SCORE': {pKey: 'categorizationShowScore', default: true},
    'CATEGORIZATION_FILE_DL': {pKey: 'categorizationShowFileDownload', default: false},
    'MH_UNLIMITED_ACCESS': {pKey: null, default: false},
}